export default __webpack_public_path__ + "static/media/david_headshot.e94e5fa8.png";